/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentMiscSettingResponseData,
  GetDocumentMiscSettingResponseDataFromJSON,
  GetDocumentMiscSettingResponseDataFromJSONTyped,
  GetDocumentMiscSettingResponseDataToJSON
} from './GetDocumentMiscSettingResponseData'

/**
 *
 * @export
 * @interface UpdateDocumentMiscSettingResponse
 */
export interface UpdateDocumentMiscSettingResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateDocumentMiscSettingResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentMiscSettingResponseData}
   * @memberof UpdateDocumentMiscSettingResponse
   */
  data?: GetDocumentMiscSettingResponseData
}

export function UpdateDocumentMiscSettingResponseFromJSON(json: any): UpdateDocumentMiscSettingResponse {
  return UpdateDocumentMiscSettingResponseFromJSONTyped(json, false)
}

export function UpdateDocumentMiscSettingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDocumentMiscSettingResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentMiscSettingResponseDataFromJSON(json['data'])
  }
}

export function UpdateDocumentMiscSettingResponseToJSON(value?: UpdateDocumentMiscSettingResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentMiscSettingResponseDataToJSON(value.data)
  }
}
